import React, { useState } from "react";
import {Outlet, Link, Route} from "react-router-dom";
import './ÜberUns.css';
import Footer from "../components/Footer";

const ÜberUns = () => {

    const [isOpen, setIsOpen] = useState(false);
        
          const toggleMobileMenu = () => {
            setIsOpen(!isOpen);
          };
          
    return(
        <section className="container-überUns"
        style={{ overflow: 'hidden'}}>
            <div className="navbar-überUns"
            style={{
                position: 'relative',
                minHeight: '100%',
                width: '100%',
                backgroundImage: 'url(/assets/ueberuns-hero.png)',
                backgroundSize: 'cover',
                backgroundRepeat: 'no-repeat',
                backgroundPosition: 'center',
                zIndex: 0,
            }}>
                {/* Burger Button (mobile only) */}
                <div className="burger-button" onClick={toggleMobileMenu}>
                    <div className="bar"></div>
                    <div className="bar"></div>
                    <div className="bar"></div>
                </div>

                {/* Mobile Menu */}
                <nav className={`mobile-menu ${isOpen ? "open" : ""}`}>
                    <Link to="/" onClick={toggleMobileMenu}>Home</Link>
                    <Link to="/leistungen" onClick={toggleMobileMenu}>Leistungen</Link>
                    <Link to="/aktuelles" onClick={toggleMobileMenu}>Aktuelles</Link>
                    <Link to="/kontakt" onClick={toggleMobileMenu}>Kontakt</Link>
                    <Link to="/impressum" onClick={toggleMobileMenu}>Impressum</Link>
                    <Link to="/datenschutz" onClick={toggleMobileMenu}>Datenschutz</Link>
                    <Link to="/blog" onClick={toggleMobileMenu}>Blog</Link>
                </nav>

                {/* Hexagon Nav (desktop) */}
                <section className="hero--inner">
                    <div className="hexagon-wrapper" id="hexagon-über-uns"><div className="hexagon"><i><Link to="/" className="link">Home</Link></i></div></div>
                    <div className="hexagon-wrapper" id="hexagon-leistungen"><div className="hexagon"><i><Link to="/leistungen" className="link">Leistungen</Link></i></div></div>
                    <div className="hexagon-wrapper" id="hexagon-aktuelles"><div className="hexagon"><i><Link to="/aktuelles" className="link">Aktuelles</Link></i></div></div>
                    <div className="hexagon-wrapper" id="hexagon-kontakt"><div className="hexagon"><i><Link to="/kontakt" className="link">Kontakt</Link></i></div></div>
                    <div className="hexagon-wrapper" id="hexagon-impressum"><div className="hexagon"><i><Link to="/impressum" className="link">Impressum</Link></i></div></div>
                    <div className="hexagon-wrapper" id="hexagon-datenschutz"><div className="hexagon"><i><Link to="/datenschutz" className="link">Datenschutz</Link></i></div></div>
                    <div className="hexagon-wrapper" id="hexagon-blog"><div className="hexagon"><i><Link to="/blog" className="link">Blog</Link></i></div></div>
                </section>
            </div>

            <div
            style={{
                position: 'relative',
                minHeight: '100%',
                width: '100%',
                backgroundImage: 'url(/assets/ueberuns-body.png)',
                backgroundSize: 'cover',
                backgroundRepeat: 'no-repeat',
                backgroundPosition: 'center',
                zIndex: 0,
            }}>
                <div className="ueberuns-container">
                    <h1 className="ueberuns-heading">Über uns</h1>

                    <section className="ueberuns-section">
                        <p>
                        Willkommen bei <strong>LAM Autoservice</strong> <br/> Ihrer Meisterwerkstatt im Herzen von Wuppertal. <br/>
                        Seit vielen Jahren stehen wir für fachkundige Reparaturen, ehrliche Beratung und persönlichen Service.
                        </p>
                        <p>
                        Unser Betrieb wird mit Leidenschaft und technischem Know-how geführt. Als anerkannter Meisterbetrieb 
                        legen wir großen Wert auf Qualität, Zuverlässigkeit und Transparenz.
                        </p>
                    </section>

                    <section className="ueberuns-section">
                        <h2>Unser Anspruch</h2>
                        <p>
                        Ob Inspektion, Reparatur oder Diagnose: Bei uns steht Ihr Fahrzeug im Mittelpunkt. 
                        Wir arbeiten markenunabhängig und verwenden ausschließlich Ersatzteile in Erstausrüsterqualität.
                        </p>
                        <p>
                        Dank modernster Technik und regelmäßiger Weiterbildungen sind wir in der Lage, 
                        auch anspruchsvolle Herausforderungen zuverlässig zu meistern.
                        </p>
                    </section>

                    <section className="ueberuns-section">
                        <h2>Warum wir?</h2>
                        <ul>
                        <li>{/*✔*/} Meistergeführte Werkstatt mit Erfahrung</li>
                        <li> Persönlicher Service & direkte Ansprechpartner</li>
                        <li> Faire Preise & transparente Abwicklung</li>
                        <li> Schnelle Termine & zuverlässige Ausführung</li>
                        </ul>
                    </section>

                    <section className="ueberuns-section">
                        <h2>Wir freuen uns auf Sie!</h2>
                        <p>
                        Ob kleiner Check oder großer Service <br/> wir sind für Sie da. Besuchen Sie uns in Wuppertal 
                        oder vereinbaren Sie direkt einen Termin.
                        </p>
                        <Link to="/kontakt" className="kontakt-button">
                            Jetzt Kontakt aufnehmen
                        </Link>
                    </section>
                </div>
            </div>
            <div className="footer-homepage">
            < Footer />
            </div>
            <Outlet />

        </section>
    );
};

export default ÜberUns;

/**
 * <div class="hexagon-wrapper">
                <div class="hexagon" id="hexagon-über-uns">
                    <i class="fab-Über-Uns"><Link to="/kontakt" class="link">Kontakt</Link></i>
                </div>
            </div>
            <div class="hexagon-wrapper" id="hexagon-leistungen">
                <div class="hexagon" >
                    <i class="fab-Leistungen"><Link to="/leistungen" class="link">Leistungen</Link></i>
                </div>
            </div>
            <div class="hexagon-wrapper" id="hexagon-aktuelles">
                <div class="hexagon">
                    <i class="fab-Aktuelles"><Link to="/aktuelles" class="link">Aktuelles</Link></i>
                </div>
            </div>
            <div class="hexagon-wrapper" id="hexagon-kontakt">
                <div class="hexagon">
                    <i class="fab-Kontakt"><Link to="/" class="link">Home</Link></i>
                </div>
            </div>
            <div class="hexagon-wrapper" id="hexagon-impressum">
                <div class="hexagon">
                    <i class="fab-Impressum"><Link to="/impressum" class="link">Impressum</Link></i>
                </div>
            </div>
            <div class="hexagon-wrapper" id="hexagon-datenschutz">
                <div class="hexagon">
                    <i class="fab-datenschutz"><Link to="/datenschutz" class="link">Datenschutz</Link></i>
                </div>
            </div>
            <div class="hexagon-wrapper" id="hexagon-blog">
                <div class="hexagon">
                    <i class="fab-blog"><Link to="/blog" class="link">Blog</Link></i>
                </div>
            </div>
 */